import { userConstants } from './../constants/user.constants';

const initialState = {};

export function BankDetails(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.UPDATINGBANKDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.UPDATINGBANKDETAILS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.UPDATINGBANKDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}